import { render, staticRenderFns } from "./LastWorkingPlaces.vue?vue&type=template&id=06b0e46e"
import script from "./LastWorkingPlaces.vue?vue&type=script&lang=js"
export * from "./LastWorkingPlaces.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports